import { Injectable } from '@angular/core';
import { AppService } from '../../service/app.service';

@Injectable({
  providedIn: 'root'
})
export class AdminService extends AppService {}
